<ng-container *ngIf="tableParams$ | async as tableParams">
  <div class="group-container">
    <markant-platform-ui-page-header
      idContent="group-assignment-overview-title"
    >
      {{ headline | defaultValue | transloco }}
    </markant-platform-ui-page-header>

    <div
      class="user-groups-info-box"
      *ngIf="
        (isLoading$ | async) === false &&
        !totalCount &&
        !tableParams.searchQuery.length
      "
    >
      <h4 class="info-box-title">
        {{ 'dashboardOverview.groupAssignment.missingGroups' | transloco }}
      </h4>
      <markant-button
        colorScheme="primary"
        id="open-dialog-create-group-button"
        (click)="toggleCreateGroupDialog(true)"
      >
        <markant-icon
          icon="m_group-large-check"
          slot="icon-leading"
        ></markant-icon>
        {{ 'dashboardOverview.groupAssignment.createNewGroup' | transloco }}
      </markant-button>
    </div>

    <div
      class="group-utils"
      *ngIf="totalCount || tableParams.searchQuery.length"
    >
      <div class="group-search">
        <markant-searchbar
          class="search-input"
          [loading]="isLoading$ | async"
          [placeholder]="
            'dashboardOverview.groupAssignment.searchPlaceholder' | transloco
          "
          [debounce]="300"
          [categories]="searchbarCategories"
          (categoryChange)="changeSearchCategory($event)"
          (valueChange)="onSearchChange($event.detail)"
        >
        </markant-searchbar>
        <div class="group-count">
          {{
            'dashboardOverview.groupAssignment.groupCount'
              | transloco: { groupCount: totalCount }
          }}
        </div>
      </div>
      <div>
        <markant-button
          colorScheme="primary"
          id="open-dialog-create-group-button"
          (click)="toggleCreateGroupDialog(true)"
        >
          <markant-icon
            icon="m_group-large-add"
            slot="icon-leading"
          ></markant-icon>
          {{ 'dashboardOverview.groupAssignment.addGroup' | transloco }}
        </markant-button>
      </div>
    </div>

    <markant-platform-table
      class="group-assignment-table"
      [data]="tableData$ | async"
      [defaultHeaderCells]="tableDraft.headerAndTableCells"
      [loading]="(isLoading$ | async) ?? false"
      [totalCount]="totalCount"
      [pageSize]="tableParams.page.size"
      [pageIndex]="tableParams.page.index"
      [class.hidden]="!totalCount && !tableParams.searchQuery.length"
      (sortChanged)="onSortChange($event)"
      (pageSizeChanged)="onPageSizeChange($event)"
      (indexChanged)="onIndexChange($event)"
    >
    </markant-platform-table>
  </div>
</ng-container>

<markant-platform-modal-bridge *ngIf="isCreateNewGroupDialogOpen">
  <markant-platform-create-new-group
    class="new-group-modal"
    (createGroup)="createNewGroup($event)"
    (openChange)="toggleCreateGroupDialog(false)"
  >
  </markant-platform-create-new-group>
</markant-platform-modal-bridge>

<markant-callout class="group-assignment-callout"></markant-callout>
